<template>
    <transition name="cz3__fade">
        <div
            v-if="showModal"
            class="z-50 fixed top-0 left-0 w-full h-full flex flex-col justify-center items-center bg-black bg-opacity-30 cz3-personalization-modal"
        >
            <div class="shadow-md rounded w-full sm:w-4/6 max-w-5xl p-4 md:p-9 flex flex-col bg-white text-ink">
                <h1 class="mb-8 text-2xl font-bold tracking-wide">
                    {{ $t('PERSONALIZATION_POLICY') }}
                </h1>

                <div
                    v-html="personalizationPolicyHtml"
                    class="flex-1 overflow-auto font-normal"
                >
                </div>

                <div class="mt-4 flex justify-end">
                    <base-button-flat
                        @click="emitClose"
                        class="w-28 h-10 capitalize"
                    >
                        {{ $t('OK') }}
                    </base-button-flat>
                </div>
            </div>
        </div>
    </transition>
</template>

<style>
    #cz3 .cz3-personalization-modal p {
        @apply mb-3;
    }
</style>

<script>
    import allStores from '../stores/all';

    import BaseButtonFlat from './BaseButtonFlat.vue';

    export default {
        mixins: [allStores],

        components: {
            BaseButtonFlat,
        },

        props: {
            showModal: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            personalizationPolicyHtml() {
                return this.customizerStore.personalizationPolicy;
            },
        },

        methods: {
            emitClose() {
                this.$emit('modalClose');
            },
        },
    };
</script>
